import React from 'react'
import SupplyOrderFormAdd from '../form/SupplyOrderFormAdd'

const SupplyOrderOptions = () => {
  return (
    <div>
		<SupplyOrderFormAdd />
    </div>
  )
}

export default SupplyOrderOptions